import { Component } from '@angular/core';

@Component({
  selector: 'webapp-compat-navigation-secondary-projects',
  template: `
    <app-navigation-secondary-projects></app-navigation-secondary-projects>
    <router-outlet></router-outlet>
  `,
})
export class CompatNavigationSecondaryProjectsComponent {}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/zh/webapp/src/compat/compat-navigation-secondary-projects.component.ts